export default "__VITE_ASSET__CSjBP2Pz__"